import React from 'react';

const ImitatingAlert = ({ currentUser, currentCompany }) => {
  return (
    <div className="ImitatingAlert">
      <span className="Label Label--info">
        #{currentUser.id} <strong>{currentUser.name}</strong> |{' '}
        {currentUser.customRole} | {currentUser.email}
      </span>
      <span className="Label Label--info">
        #{currentCompany.id} <strong>{currentCompany.name}</strong>
      </span>
    </div>
  );
};

export default ImitatingAlert;
